import React from 'react';
import { format } from 'date-fns';
import Spinner from '../../../shared/components/Spinner';

const StockMovementTable = ({ movements = [], loading = false, onView }) => {
  if (loading) {
    return (
      <div className="flex justify-center py-6">
        <Spinner size="md" />
      </div>
    );
  }

  if (!movements || movements.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        No stock movements found.
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
              Date
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
              Type
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
              Quantity
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
              Reference
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
              Remarks
            </th>
            {onView && (
              <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase">
                Action
              </th>
            )}
          </tr>
        </thead>

        <tbody className="bg-white divide-y divide-gray-200">
          {movements.map((movement) => (
            <tr key={movement.id} className="hover:bg-gray-50">
              <td className="px-4 py-2 text-sm text-gray-700">
                {movement.created_at
                  ? format(new Date(movement.created_at), 'MMM dd, yyyy')
                  : '—'}
              </td>

              <td className="px-4 py-2 text-sm">
                <span
                  className={`px-2 py-1 rounded-full text-xs font-medium ${
                    movement.type === 'IN'
                      ? 'bg-green-100 text-green-700'
                      : movement.type === 'OUT'
                      ? 'bg-red-100 text-red-700'
                      : 'bg-gray-100 text-gray-700'
                  }`}
                >
                  {movement.type}
                </span>
              </td>

              <td className="px-4 py-2 text-sm font-medium text-gray-800">
                {movement.quantity}
              </td>

              <td className="px-4 py-2 text-sm text-gray-700">
                {movement.reference || '—'}
              </td>

              <td className="px-4 py-2 text-sm text-gray-700">
                {movement.remarks || '—'}
              </td>

              {onView && (
                <td className="px-4 py-2 text-right">
                  <button
                    onClick={() => onView(movement)}
                    className="text-primary-600 hover:text-primary-800 text-sm font-medium"
                  >
                    View
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StockMovementTable;